module.exports = __webpack_public_path__ + "static/media/JINDALSTEL_F1.3b9c0a4b.txt";